import * as types from "./types";

export async function setLoading({ commit }, payload) {
  try {
    commit(types.SET_LOADING, payload.bool);
    commit(types.SET_LOADING_ICON, payload.icon + "");
  } catch (e) {
    console.log(e);
  }
}

export async function setPrintoutLink({ commit }, payload) {
  try {
    commit(types.SET_PRINTOUT_LINK, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function setDebugMode({ commit }, payload) {
  try {
    commit(types.IS_DEBUG, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setInManagement({ commit }, payload) {
  try {
    commit(types.IS_IN_MANAGEMENT, payload);
  } catch (e) {
    console.log(e);
  }
}
